import type { Species } from "@/utils/nutritionMath";

export type VerifiedFoodFormat = "dry" | "wet";
export type VerifiedFoodConfidence = "V" | "R";

export interface VerifiedFood {
  id: string;
  species: Species;
  format: VerifiedFoodFormat;
  brand: string;
  product: string;
  kcalPerKg: number;
  kcalPerCup?: number;
  secondaryLabel?: string;
  confidence: VerifiedFoodConfidence;
  sourceLabel: string;
  sourceCapturedDate: "2026-05";
}

export const verifiedFoods: VerifiedFood[] = [
  {
    id: "dog-1",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Complete Essentials Adult Shredded Blend Chicken & Rice",
    kcalPerKg: 3790,
    kcalPerCup: 369,
    confidence: "V",
    sourceLabel: "purina.com / proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-2",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "SAVOR Shredded Blend Adult Chicken & Rice",
    kcalPerKg: 3997,
    kcalPerCup: 382,
    confidence: "V",
    sourceLabel: "proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-3",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Adult Small Breed Chicken & Rice",
    kcalPerKg: 4012,
    kcalPerCup: 448,
    confidence: "V",
    sourceLabel: "purina.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-4",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Puppy Chicken & Rice",
    kcalPerKg: 4188,
    kcalPerCup: 456,
    confidence: "V",
    sourceLabel: "shop.purina.com / proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-5",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Puppy Large Breed Chicken & Rice",
    kcalPerKg: 3934,
    kcalPerCup: 419,
    confidence: "V",
    sourceLabel: "proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-6",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Puppy Shredded Blend Chicken & Rice",
    kcalPerKg: 4167,
    kcalPerCup: 406,
    confidence: "V",
    sourceLabel: "proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-7",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Sport Performance 30/20 Chicken & Rice",
    kcalPerKg: 4390,
    kcalPerCup: 484,
    confidence: "V",
    sourceLabel: "purina.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-8",
    species: "dog",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Adult Sensitive Skin & Stomach Salmon & Rice",
    kcalPerKg: 3903,
    kcalPerCup: 449,
    confidence: "V",
    sourceLabel: "proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-9",
    species: "dog",
    format: "dry",
    brand: "Purina ONE",
    product: "SmartBlend Chicken & Rice Adult",
    kcalPerKg: 3993,
    kcalPerCup: 383,
    confidence: "R",
    sourceLabel: "purina.com (on-pack)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-10",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult 1-6 Chicken & Barley",
    kcalPerKg: 3657,
    kcalPerCup: 363,
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-11",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult Large Breed Chicken & Barley",
    kcalPerKg: 3675,
    kcalPerCup: 365,
    confidence: "V",
    sourceLabel: "hillspet.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-12",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult Perfect Weight Chicken",
    kcalPerKg: 3756,
    kcalPerCup: 394,
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-13",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult Light Chicken Meal & Barley",
    kcalPerKg: 2987,
    kcalPerCup: 271,
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-14",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult 7+ Small Bites Chicken, Barley & Rice",
    kcalPerKg: 3558,
    kcalPerCup: 353,
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-15",
    species: "dog",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Small & Mini Senior Vitality Chicken & Rice",
    kcalPerKg: 3649,
    kcalPerCup: 341,
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-16",
    species: "dog",
    format: "dry",
    brand: "Blue Buffalo",
    product: "Life Protection Adult Chicken & Brown Rice",
    kcalPerKg: 3633,
    kcalPerCup: 379,
    confidence: "R",
    sourceLabel: "chewy.com (BLUE statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-17",
    species: "dog",
    format: "dry",
    brand: "Blue Buffalo",
    product: "Life Protection Puppy Chicken & Brown Rice",
    kcalPerKg: 3717,
    kcalPerCup: 401,
    confidence: "R",
    sourceLabel: "chewy.com / Publix",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-18",
    species: "dog",
    format: "dry",
    brand: "Blue Buffalo",
    product: "Life Protection Senior Chicken & Brown Rice",
    kcalPerKg: 3416,
    kcalPerCup: 343,
    confidence: "R",
    sourceLabel: "chewy.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-19",
    species: "dog",
    format: "dry",
    brand: "Blue Buffalo",
    product: "Life Protection Healthy Weight Adult Chicken & Brown Rice",
    kcalPerKg: 3264,
    kcalPerCup: 322,
    confidence: "R",
    sourceLabel: "chewy.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-20",
    species: "dog",
    format: "dry",
    brand: "Royal Canin (US)",
    product: "Size Health Nutrition Medium Adult",
    kcalPerKg: 3616,
    kcalPerCup: 340,
    confidence: "V",
    sourceLabel: "royalcanin.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-21",
    species: "dog",
    format: "dry",
    brand: "Royal Canin (US)",
    product: "Size Health Nutrition Small Adult",
    kcalPerKg: 3744,
    kcalPerCup: 359,
    confidence: "V",
    sourceLabel: "royalcanin.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-22",
    species: "dog",
    format: "dry",
    brand: "Nutro",
    product: "Natural Choice Adult Chicken & Brown Rice",
    kcalPerKg: 3631,
    kcalPerCup: 357,
    confidence: "R",
    sourceLabel: "nutro.com (via PetSmart)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-23",
    species: "dog",
    format: "dry",
    brand: "Nutro",
    product: "Natural Choice Large Breed Adult Chicken & Brown Rice",
    kcalPerKg: 3617,
    kcalPerCup: 335,
    confidence: "R",
    sourceLabel: "nutro.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-24",
    species: "dog",
    format: "dry",
    brand: "Nutro",
    product: "Natural Choice Healthy Weight Adult Chicken & Brown Rice",
    kcalPerKg: 3167,
    kcalPerCup: 264,
    confidence: "R",
    sourceLabel: "petsmart.com (Nutro statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-25",
    species: "dog",
    format: "dry",
    brand: "Taste of the Wild",
    product: "High Prairie Canine (Bison & Venison)",
    kcalPerKg: 3719,
    kcalPerCup: 422,
    confidence: "V",
    sourceLabel: "tasteofthewildpetfood.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-26",
    species: "dog",
    format: "dry",
    brand: "Acana",
    product: "Adult Dog Recipe (grain-free)",
    kcalPerKg: 3510,
    kcalPerCup: 421,
    confidence: "V",
    sourceLabel: "acana.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-27",
    species: "dog",
    format: "dry",
    brand: "Wellness",
    product: "Complete Health Adult Chicken & Oatmeal",
    kcalPerKg: 3584,
    kcalPerCup: 427,
    confidence: "R",
    sourceLabel: "chewy.com (Wellness statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-28",
    species: "dog",
    format: "dry",
    brand: "Iams",
    product: "ProActive Health Large Breed Adult",
    kcalPerKg: 3561,
    kcalPerCup: 354,
    confidence: "R",
    sourceLabel: "petsmart.com (Iams statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-29",
    species: "dog",
    format: "wet",
    brand: "Purina Pro Plan",
    product: "Sensitive Skin & Stomach Salmon & Rice Entree Classic",
    kcalPerKg: 1006,
    secondaryLabel: "370 kcal/13 oz can",
    confidence: "V",
    sourceLabel: "proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-30",
    species: "dog",
    format: "wet",
    brand: "Hill's Science Diet",
    product: "Adult 7+ Chicken & Barley Entree",
    kcalPerKg: 1013,
    secondaryLabel: "375 kcal/13 oz can",
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-31",
    species: "dog",
    format: "wet",
    brand: "Hill's Science Diet",
    product: "Puppy Chicken & Barley Entree",
    kcalPerKg: 1339,
    secondaryLabel: "495 kcal/13 oz can",
    confidence: "R",
    sourceLabel: "hillspet.com (via Pet Food Express)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-32",
    species: "dog",
    format: "wet",
    brand: "Cesar",
    product: "Classic Loaf in Sauce Grilled Chicken",
    kcalPerKg: 867,
    secondaryLabel: "87 kcal/3.5 oz tray",
    confidence: "R",
    sourceLabel: "petsmart.com / cesar.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-33",
    species: "dog",
    format: "wet",
    brand: "Pedigree",
    product: "Chopped Ground Dinner Chicken & Rice",
    kcalPerKg: 1137,
    secondaryLabel: "427 kcal/13.2 oz can",
    confidence: "R",
    sourceLabel: "petsmart.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-34",
    species: "dog",
    format: "wet",
    brand: "Pedigree",
    product: "Chopped Ground Dinner Turkey & Bacon",
    kcalPerKg: 1080,
    secondaryLabel: "405 kcal/13.2 oz can",
    confidence: "R",
    sourceLabel: "petsmart.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-35",
    species: "dog",
    format: "wet",
    brand: "Iams",
    product: "ProActive Health Adult Classic Ground Chicken & Rice",
    kcalPerKg: 1024,
    secondaryLabel: "378 kcal/13 oz can",
    confidence: "R",
    sourceLabel: "publix.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-36",
    species: "dog",
    format: "wet",
    brand: "Blue Buffalo",
    product: "Homestyle Recipe Adult Chicken Dinner",
    kcalPerKg: 1114,
    secondaryLabel: "392 kcal/12.5 oz can",
    confidence: "R",
    sourceLabel: "chewy.com (BLUE statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-37",
    species: "dog",
    format: "wet",
    brand: "Wellness",
    product: "Complete Health Adult Chicken & Sweet Potato",
    kcalPerKg: 1096,
    secondaryLabel: "386 kcal/12.5 oz can",
    confidence: "R",
    sourceLabel: "chewy.com (Wellness statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-38",
    species: "dog",
    format: "wet",
    brand: "Cesar",
    product: "Classic Loaf in Sauce Filet Mignon",
    kcalPerKg: 820,
    secondaryLabel: "82 kcal/3.5 oz tray",
    confidence: "R",
    sourceLabel: "petsmart.com / cesar.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-39",
    species: "cat",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult Indoor Chicken",
    kcalPerKg: 3492,
    kcalPerCup: 327,
    confidence: "V",
    sourceLabel: "hillspet.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-40",
    species: "cat",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult Chicken Recipe (Original)",
    kcalPerKg: 3873,
    kcalPerCup: 483,
    confidence: "V",
    sourceLabel: "hillspet.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-41",
    species: "cat",
    format: "dry",
    brand: "Royal Canin (US)",
    product: "Feline Health Nutrition Indoor Adult",
    kcalPerKg: 3534,
    kcalPerCup: 325,
    confidence: "V",
    sourceLabel: "royalcanin.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-42",
    species: "cat",
    format: "dry",
    brand: "Purina Pro Plan",
    product: "Adult Sensitive Skin & Stomach Salmon & Rice",
    kcalPerKg: 3915,
    kcalPerCup: 492,
    confidence: "V",
    sourceLabel: "shop.purina.com / proplanvetdirect.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-43",
    species: "cat",
    format: "dry",
    brand: "Purina ONE",
    product: "Sensitive Skin & Stomach (Turkey)",
    kcalPerKg: 3781,
    kcalPerCup: 429,
    confidence: "R",
    sourceLabel: "purina.com (via Lowes Foods)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-44",
    species: "cat",
    format: "dry",
    brand: "Friskies",
    product: "Surfin' & Turfin' Favorites",
    kcalPerKg: 3573,
    kcalPerCup: 392,
    confidence: "R",
    sourceLabel: "purina.com (via retailers)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-45",
    species: "cat",
    format: "dry",
    brand: "Friskies",
    product: "Seafood Sensations",
    kcalPerKg: 3644,
    kcalPerCup: 388,
    confidence: "V",
    sourceLabel: "purina.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-46",
    species: "cat",
    format: "dry",
    brand: "Purina Cat Chow",
    product: "Gentle Sensitive Stomach + Skin",
    kcalPerKg: 3603,
    kcalPerCup: 402,
    confidence: "R",
    sourceLabel: "purina.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-47",
    species: "cat",
    format: "dry",
    brand: "Iams",
    product: "ProActive Health Indoor Weight & Hairball Chicken & Turkey",
    kcalPerKg: 3329,
    kcalPerCup: 299,
    confidence: "R",
    sourceLabel: "iams (via retailer statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-48",
    species: "cat",
    format: "dry",
    brand: "Meow Mix",
    product: "Original Choice",
    kcalPerKg: 3500,
    kcalPerCup: 308,
    confidence: "V",
    sourceLabel: "meowmix.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-49",
    species: "cat",
    format: "dry",
    brand: "Blue Buffalo",
    product: "Indoor Health Chicken & Brown Rice (cat)",
    kcalPerKg: 3524,
    kcalPerCup: 351,
    confidence: "R",
    sourceLabel: "chewy.com (BLUE statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-50",
    species: "cat",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Adult 7+ Indoor Chicken (cat)",
    kcalPerKg: 3636,
    kcalPerCup: 333,
    confidence: "V",
    sourceLabel: "hillspet.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-51",
    species: "cat",
    format: "dry",
    brand: "Hill's Science Diet",
    product: "Kitten Chicken Recipe",
    kcalPerKg: 4128,
    kcalPerCup: 524,
    confidence: "V",
    sourceLabel: "hillspet.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-52",
    species: "cat",
    format: "dry",
    brand: "Wellness",
    product: "Complete Health Adult Indoor Chicken (cat)",
    kcalPerKg: 3632,
    kcalPerCup: 439,
    confidence: "R",
    sourceLabel: "chewy.com (Wellness statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-53",
    species: "cat",
    format: "dry",
    brand: "Purina ONE",
    product: "Tender Selects Blend Real Chicken (cat)",
    kcalPerKg: 3942,
    kcalPerCup: 370,
    confidence: "R",
    sourceLabel: "purina.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-54",
    species: "cat",
    format: "dry",
    brand: "Iams",
    product: "ProActive Health Healthy Adult Original Chicken (cat)",
    kcalPerKg: 3884,
    kcalPerCup: 432,
    confidence: "R",
    sourceLabel: "iams (via retailer statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-55",
    species: "cat",
    format: "dry",
    brand: "Royal Canin (UK/EU)",
    product: "Indoor 27 (cat)",
    kcalPerKg: 3738,
    confidence: "V",
    sourceLabel: "royalcanin.com UK",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-56",
    species: "cat",
    format: "dry",
    brand: "Concept for Life",
    product: "Indoor Cats",
    kcalPerKg: 3859,
    secondaryLabel: "386 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-57",
    species: "cat",
    format: "dry",
    brand: "Concept for Life",
    product: "Sterilised Cats Salmon",
    kcalPerKg: 3498,
    secondaryLabel: "350 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-58",
    species: "cat",
    format: "dry",
    brand: "Concept for Life",
    product: "Kitten",
    kcalPerKg: 4143,
    secondaryLabel: "414 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-59",
    species: "cat",
    format: "dry",
    brand: "Concept for Life",
    product: "Light Adult",
    kcalPerKg: 3491,
    secondaryLabel: "349 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-60",
    species: "cat",
    format: "dry",
    brand: "Concept for Life",
    product: "Beauty Adult",
    kcalPerKg: 4131,
    secondaryLabel: "413 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-61",
    species: "cat",
    format: "wet",
    brand: "Fancy Feast",
    product: "Classic Pate Chicken Feast",
    kcalPerKg: 1080,
    secondaryLabel: "91 kcal/3 oz can",
    confidence: "V",
    sourceLabel: "purina.com / Publix",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-62",
    species: "cat",
    format: "wet",
    brand: "Fancy Feast",
    product: "Classic Pate Savory Salmon Feast",
    kcalPerKg: 1029,
    secondaryLabel: "87 kcal/3 oz can",
    confidence: "R",
    sourceLabel: "purina.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-63",
    species: "cat",
    format: "wet",
    brand: "Fancy Feast",
    product: "Petites Braised Chicken Entree",
    kcalPerKg: 1166,
    secondaryLabel: "46 kcal/serving",
    confidence: "R",
    sourceLabel: "purina.com (via Walmart)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-64",
    species: "cat",
    format: "wet",
    brand: "Fancy Feast",
    product: "Petites Wild Alaskan Salmon Entree",
    kcalPerKg: 1074,
    secondaryLabel: "43 kcal/serving",
    confidence: "R",
    sourceLabel: "purina.com (via Walmart)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-65",
    species: "cat",
    format: "wet",
    brand: "Fancy Feast",
    product: "Petites Ocean Whitefish & Tuna Entree",
    kcalPerKg: 1014,
    secondaryLabel: "41 kcal/serving",
    confidence: "R",
    sourceLabel: "purina.com (via Walmart)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-66",
    species: "cat",
    format: "wet",
    brand: "Friskies",
    product: "Pate Salmon Dinner",
    kcalPerKg: 1145,
    secondaryLabel: "178 kcal/5.5 oz can",
    confidence: "R",
    sourceLabel: "purina.com (via Lowes Foods)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-67",
    species: "cat",
    format: "wet",
    brand: "Friskies",
    product: "Pate Chicken & Tuna Dinner",
    kcalPerKg: 1244,
    secondaryLabel: "194 kcal/5.5 oz can",
    confidence: "R",
    sourceLabel: "purina.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-68",
    species: "cat",
    format: "wet",
    brand: "Sheba",
    product: "Perfect Portions Pate Sustainable Salmon",
    kcalPerKg: 898,
    secondaryLabel: "34 kcal/2.6 oz tray",
    confidence: "R",
    sourceLabel: "sheba.com (via Stater Bros)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-69",
    species: "cat",
    format: "wet",
    brand: "Sheba",
    product: "Perfect Portions Cuts in Gravy Roasted Chicken",
    kcalPerKg: 766,
    secondaryLabel: "29 kcal/2.6 oz tray",
    confidence: "R",
    sourceLabel: "sheba.com (via Lowes Foods)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-70",
    species: "cat",
    format: "wet",
    brand: "Sheba",
    product: "Perfect Portions Kitten Chicken Pate",
    kcalPerKg: 1131,
    secondaryLabel: "42 kcal/tray",
    confidence: "R",
    sourceLabel: "sheba.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-71",
    species: "cat",
    format: "wet",
    brand: "Royal Canin (US)",
    product: "Kitten Thin Slices in Gravy",
    kcalPerKg: 893,
    secondaryLabel: "76 kcal/3 oz can",
    confidence: "V",
    sourceLabel: "royalcanin.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-72",
    species: "cat",
    format: "wet",
    brand: "Royal Canin (EU)",
    product: "Indoor Sterilised in Jelly",
    kcalPerKg: 801,
    secondaryLabel: "68 kcal/85 g pouch",
    confidence: "R",
    sourceLabel: "zooplus.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-73",
    species: "cat",
    format: "wet",
    brand: "Hill's Science Diet",
    product: "Adult Tender Chicken Dinner (cat)",
    kcalPerKg: 942,
    secondaryLabel: "147 kcal/5.5 oz can",
    confidence: "R",
    sourceLabel: "hillspet.com (via retailer)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-74",
    species: "cat",
    format: "wet",
    brand: "Whiskas",
    product: "1+ Poultry Feasts in Jelly",
    kcalPerKg: 770,
    secondaryLabel: "60 kcal/85 g pouch",
    confidence: "R",
    sourceLabel: "whiskas.co.uk (via retailers)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-75",
    species: "cat",
    format: "wet",
    brand: "Felix",
    product: "As Good As It Looks Chicken in Jelly",
    kcalPerKg: 750,
    secondaryLabel: "75 kcal/100 g pouch",
    confidence: "R",
    sourceLabel: "purina (via Pets at Home)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-76",
    species: "cat",
    format: "wet",
    brand: "Concept for Life",
    product: "Veterinary Diet Weight Control (pouch)",
    kcalPerKg: 760,
    secondaryLabel: "76 kcal/100 g",
    confidence: "R",
    sourceLabel: "zooplus.com (FEDIAF)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-78",
    species: "cat",
    format: "wet",
    brand: "Wellness",
    product: "Complete Health Pate Chicken (cat)",
    kcalPerKg: 1100,
    secondaryLabel: "94 kcal/3 oz can",
    confidence: "R",
    sourceLabel: "chewy.com (Wellness statement)",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-thrive-chicken-complete-wet",
    species: "dog",
    format: "wet",
    brand: "Thrive",
    product: "Chicken Complete Wet Dog Food",
    kcalPerKg: 1060,
    secondaryLabel: "106 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-thrive-lamb-complete-wet",
    species: "dog",
    format: "wet",
    brand: "Thrive",
    product: "Lamb Complete Wet Dog Food",
    kcalPerKg: 1070,
    secondaryLabel: "107 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-thrive-venison-complete-wet",
    species: "dog",
    format: "wet",
    brand: "Thrive",
    product: "Venison Complete Wet Dog Food",
    kcalPerKg: 1090,
    secondaryLabel: "109 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "dog-thrive-chicken-complete-puppy-wet",
    species: "dog",
    format: "wet",
    brand: "Thrive",
    product: "Chicken Complete Wet Puppy Food",
    kcalPerKg: 930,
    secondaryLabel: "93 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-premiumplus-chicken-dry",
    species: "cat",
    format: "dry",
    brand: "Thrive",
    product: "PremiumPlus Chicken Complete Dry Cat Food",
    kcalPerKg: 4090,
    secondaryLabel: "409 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-premiumplus-chicken-turkey-dry",
    species: "cat",
    format: "dry",
    brand: "Thrive",
    product: "PremiumPlus Chicken with Turkey Complete Dry Cat Food",
    kcalPerKg: 4110,
    secondaryLabel: "411 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-premiumplus-salmon-herring-dry",
    species: "cat",
    format: "dry",
    brand: "Thrive",
    product: "PremiumPlus Salmon and Herring Complete Dry Cat Food",
    kcalPerKg: 3920,
    secondaryLabel: "392 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-chicken-breast-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Chicken Breast Complete Wet Cat Food",
    kcalPerKg: 740,
    secondaryLabel: "74 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-chicken-breast-turkey-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Chicken Breast and Turkey Complete Wet Cat Food",
    kcalPerKg: 690,
    secondaryLabel: "69 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-chicken-breast-liver-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Chicken Breast and Chicken Liver Complete Wet Cat Food",
    kcalPerKg: 740,
    secondaryLabel: "74 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-ocean-fish-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Ocean Fish Complete Wet Cat Food",
    kcalPerKg: 650,
    secondaryLabel: "65 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-sardine-mackerel-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Sardine and Mackerel Complete Wet Cat Food",
    kcalPerKg: 770,
    secondaryLabel: "77 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-tuna-vegetable-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Tuna with Vegetable Complete Wet Cat Food",
    kcalPerKg: 740,
    secondaryLabel: "74 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
  {
    id: "cat-thrive-tuna-salmon-complete-wet",
    species: "cat",
    format: "wet",
    brand: "Thrive",
    product: "Tuna and Salmon Complete Wet Cat Food",
    kcalPerKg: 690,
    secondaryLabel: "69 kcal/100g",
    confidence: "V",
    sourceLabel: "thrivepetfoods.com",
    sourceCapturedDate: "2026-05",
  },
];

export const verifiedFoodsById = new Map(verifiedFoods.map((food) => [food.id, food]));
